import Offcanvas from 'bootstrap/js/dist/offcanvas';

export function initOffcanvas (): void {
    const toggleBtn = document.querySelector('#navbarSideCollapse');
    const offcanvasCollapse = document.querySelector('.offcanvas-collapse');

    if (!toggleBtn || !offcanvasCollapse) {
        return;
    }

    toggleBtn.addEventListener('click', () => {
        offcanvasCollapse.classList.toggle('open');
    });


    document.addEventListener("DOMContentLoaded", () => {
        const offcanvas = document.getElementById("offcanvasNavbar");
        if (!offcanvas) return;

        let scrollY = 0;

        offcanvas.addEventListener("show.bs.offcanvas", () => {
            scrollY = window.scrollY;

            document.documentElement.classList.add("offcanvas-open-lock");
            document.body.classList.add("offcanvas-open-lock");

            document.body.style.top = `-${scrollY}px`;
        });

        offcanvas.addEventListener("hidden.bs.offcanvas", () => {
            document.documentElement.classList.remove("offcanvas-open-lock");
            document.body.classList.remove("offcanvas-open-lock");

            document.body.style.top = "";
            window.scrollTo(0, scrollY);
        });

        document.querySelectorAll<HTMLElement>('.offcanvas').forEach((el) => {
            Offcanvas.getOrCreateInstance(el)
        })
    });
}